import React from "react";
import { useParams } from "react-router-dom";
import ShowCustomer from "./ShowCustomer";

function LeadDetails({ nextCall }) {
  const { id } = useParams();

  return (
    <div>
        <ShowCustomer
          caseId={id}
          nextCall={nextCall}
          arrowHide={true}
          showCustomerInFull={true}
          hideArrow={true}
        />
    </div>
  );
}

export default LeadDetails;
